module.exports = __webpack_public_path__ + "img/3.2df658ff.png";